((document, window) => {
    const RADIO_SELECTOR = '.js-orc-collectionRadio';
  
    function waitForOkendo(callback) {
      if (window.okeWidgetApi) {
        callback();
        return;
      }
  
      const interval = setInterval(() => {
        if (window.okeWidgetApi) {
          clearInterval(interval);
          callback();
        }
      }, 100);
    }
  
    function setupCollectionControls() {
      const widgets = document.querySelectorAll('[data-oke-widget]');
      const snippetEl = widgets[widgets.length - 1];
  
      const review_collection = document.querySelectorAll('.orc-allReviewsCollections');
      const controlEl = review_collection[review_collection.length - 1];
  
      const radios = Array.from(document.querySelectorAll(RADIO_SELECTOR));
  
      if (!snippetEl || !controlEl) return;
  
      // Prevent duplicate initialization
      if (controlEl.dataset.initialized === "true") return;
      controlEl.dataset.initialized = "true";
  
      controlEl.style.display = 'block';
  
      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
  
          if (radio.value) {
  
            if (radio.value.toLowerCase().startsWith('shopify-')) {
              snippetEl.removeAttribute('data-oke-reviews-group-id');
              window.okeWidgetApi.setProduct(snippetEl, radio.value);
  
            } else {
              snippetEl.removeAttribute('data-oke-reviews-product-id');
              window.okeWidgetApi.setGroup(snippetEl, radio.value);
            }
  
          } else {
  
            snippetEl.removeAttribute('data-oke-reviews-group-id');
            snippetEl.removeAttribute('data-oke-reviews-product-id');
            snippetEl.innerHTML = '';
            window.okeWidgetApi.initWidget(snippetEl, true);
          }
  
          radios.forEach(el =>
            el.classList.remove('orc-collectionControls-item-input--checked')
          );
  
          radio.classList.add('orc-collectionControls-item-input--checked');
        });
      });
    }
    function init() {
        waitForOkendo(setupCollectionControls);
      }
    
      // Run when DOM is ready
      document.addEventListener('DOMContentLoaded', init);
    
      // Fallback if Okendo renders later
      document.addEventListener('oke-rendered', function(e) {
        if (e.detail.widget === 'reviews-widget') {
          setupCollectionControls();
        }
      });
    
    })(document, window);
    